export default __webpack_public_path__ + "static/media/mascot_user.2b2c1846.svg";